import {getCurrentInstance, onMounted, onUnmounted, ref} from 'vue';
import {SharedBreakpointsOptions} from './types';
import {useBreakpointOperations} from './useBreakpointOperations';

/**
 * Return reactive computed variables based on browser window size

 * ### ⚠️ Only use inside `setup` function or in a composable
 *
 * @example
 *
 * ```ts
 *  const {windowWidth, currentBreakpoint, matchMedia} = useMediaQuery();
 *
 *  const isSmall = computed(() => matchMedia.value.max.md)
 * ```
 */
export function useMediaQuery(options?: SharedBreakpointsOptions) {
    const windowWidth = ref(window.document.documentElement.clientWidth);
    const windowHeight = ref(window.document.documentElement.clientHeight);

    const {handleResize, currentBreakpoint, matchMedia} = useBreakpointOperations({
        container: window.document.documentElement,
        containerWidth: windowWidth,
        containerHeight: windowHeight,
        options,
    });

    if (getCurrentInstance()) {
        onMounted(() => {
            window.addEventListener('resize', handleResize);
            handleResize();
        });

        onUnmounted(() => {
            window.removeEventListener('resize', handleResize);
        });
    }

    return {
        windowHeight,
        windowWidth,
        currentBreakpoint,
        matchMedia,
    };
}
